import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";

const StackedBarChart = ({ data }) => {
  const LOAN_TYPE_COLORS = {
    "Business Loan": "#1E3A8A",
    "Check-off Loan": "#0EA5E9",
    "Development Loan": "#10B981",
    "Flash Loan": "#F59E0B",
    "Normal Loan": "#8B5CF6",
    "Emergency Loan": "#EF4444",
  };
  const isApiFormat =
    data && data?.labels && data?.series && Array?.isArray(data?.labels);

  // Transform API structure
  const chartData = isApiFormat
    ? data?.labels?.map((label, index) => {
        const row = { date: label };

        data?.series?.forEach((serie) => {
          row[serie?.label] = serie?.data[index];
        });

        return row;
      })
    : data;

  if (!chartData || chartData?.length === 0) {
    return (
      <div className="w-full h-[280px] flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <p className="text-gray-600">No data available</p>
      </div>
    );
  }

  // Get all series labels dynamically
  const seriesKeys = isApiFormat
    ? data?.series?.map((serie) => serie?.label)
    : Object?.keys(chartData[0])?.filter((key) => key !== "date");

  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 20, left: -20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey="date" axisLine={{ stroke: "#D9D9D9" }}>
          <Label
            value={
              isApiFormat
                ? {
                    day: "Days",
                    week: "Weeks",
                    month: "Months",
                    year: "Years",
                  }[data?.bucket] || "Periods"
                : "Days"
            }
            position="insideBottom"
            offset={-10}
          />
        </XAxis>

        <YAxis
          width={100}
          tickFormatter={(value) => new Intl.NumberFormat().format(value)}
          axisLine={{ stroke: "#D9D9D9" }}
        />

        <Tooltip
          formatter={(value) => new Intl.NumberFormat()?.format(value)}
        />

        <Legend
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{ paddingTop: 10 }}
        />

        {seriesKeys?.map((key) => (
          <Bar
            key={key}
            dataKey={key}
            stackId="a"
            fill={LOAN_TYPE_COLORS[key] || "#94A3B8"}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart;
